module.exports = __webpack_public_path__ + "img/63.5e0f0207.png";